import React, { useState, useEffect } from "react";
import "./customerInfo.css"
import { Mixpanel } from "../../Mixpanel";

function CustomerInfo(props) {
    
    const states = ['Alabama','Alaska','Arizona','Arkansas','California','Colorado','Connecticut','Delaware','Florida','Georgia','Hawaii','Idaho','Illinois','Indiana','Iowa','Kansas','Kentucky','Louisiana','Maine','Maryland','Massachusetts','Michigan','Minnesota','Mississippi','Missouri','Montana','Nebraska','Nevada','New Hampshire','New Jersey','New Mexico','New York','North Carolina','North Dakota','Ohio','Oklahoma','Oregon','Pennsylvania','Rhode Island','South Carolina','South Dakota','Tennessee','Texas','Utah','Vermont','Virginia','Washington','West Virginia','Wisconsin','Wyoming']

    const changeName = (ev)=>{
        props.setName(ev.target.value)

    }
    const changeNumber = (ev)=>{
        props.setNumber(ev.target.value)
    }
    const changeEmail = (ev)=>{
        props.setEmail(ev.target.value)
        localStorage.setItem("email", ev.target.value)

        
    }
    const changeStreet = (ev)=>{
        props.setStreet(ev.target.value)

    }
    const changeStreet2 = (ev)=>{
        props.setStreet2(ev.target.value)
        
    }
    const changeCity = (ev)=>{
        props.setCity(ev.target.value)
  
    }
    const changeState = (ev)=>{
        props.setState(ev.target.value)
        
    }
    const changePostcode = (ev)=>{
        props.setPostcode(ev.target.value)
       
    }

    return(
        <div className="customerInfo">
            {/* <div className="billingField">
            <p>Full Name: *</p>
            <input type="text" value={props.name} onChange={changeName} />
            </div>
            <div className="billingField">
                <p>Country (we only ship to the US currently)</p>
                <select disabled >
                    <option value="United States">United States</option>
                </select>
            </div> */}
            {/* <div className="billingField">
            <p>Phone Number: *</p>
            <input type="number" value={props.number} onChange={changeNumber} />
            </div> */}
            {/* <div className="billingField">
            <p>Contact:</p>
            <p>Email: *</p>
            <input placeholder="Email" type="text" value={props.email} onChange={changeEmail} />
            </div> */}
            {/* <div className="billingField">
                <p>Delivery Date</p>
                <select disabled name="" id="">
                    <option value="december">Before or On December 20th</option>
                </select>
            </div> */}
            {/* <p>*Click on of the buttons below to enter billing and shipping details</p> */}
            {/* <div className="billingField">
            <p>Street Address: *</p>
            <input type="text" value={props.street} onChange={changeStreet} />
            </div>
            <div className="billingField">
            <input type="text" value={props.street2} onChange={changeStreet2} />
            </div>
            <div className="billingField">
            <p>City: *</p>
            <input type="text" value={props.city} onChange={changeCity} />
            </div>
            <div className="billingField">
                <p>State: *</p>
                <select value={props.state} onChange={changeState}>
                    {
                        states.map((state,index)=>{
                            return(
                                <option value={state}>{state}</option>
                            )
                        })
                    }
                </select>
            </div>
            <div className="billingField">
            <p>Zip Code: *</p>
            <input type="text" value={props.postcode} onChange={changePostcode} />
            </div> */}
            
            
            
            
            
            
        </div>
    )
}

export default CustomerInfo